import React, { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import { CustomerActionIds } from 'types/atoms/atom.customers'
import { customerActionAtom } from '../atoms/customersAtoms'
import { AssignCustomerFeeWallets } from './AssignCustomerFeeWallets'
import { SetCustomerFees } from './SetCustomerFees'

interface CustomerSheetProps {
  isSheetOpen: boolean
  isNestedSheet?: boolean
}

export const CustomersSheets = ({ isSheetOpen, isNestedSheet = false }: CustomerSheetProps) => {
  const customerAction = useAtomValue(customerActionAtom)
  const { onBack, onClose, header, subHeader } = customerAction || {}

  const sheetContent = useMemo(() => {
    if (!customerAction) return null

    switch (customerAction?.actionId) {
      case CustomerActionIds.ASSIGN_FEE_WALLETS:
        return <AssignCustomerFeeWallets />
      case CustomerActionIds.ASSIGN_CUSTOMER_FEE:
        return <SetCustomerFees />
      default:
        return null
    }
  }, [customerAction])

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={onClose}
      subHeader={subHeader}
      isNestedSheet={isNestedSheet}
    >
      {sheetContent}
    </Sheet>
  )
}
